import React from 'react';
import { useTranslation } from 'react-i18next';

import { getIsMsgOutgoing } from 'widget/actions';
import { MsgText, Plug } from './components';
import { Text } from 'widget/components';
import { useChatBodyContext } from 'widget/content/chat/chat-body/chat-body-context';
import { useIsMutedDark } from 'widget/hooks';
import { useMsgContext } from '../msg-context';
import { useWidgetContext } from 'widget/widget-context';

import Ack from './ack/ack';
import File from './file/file';
import QuotedMsg from './quoted-msg/quoted-msg';
import Reactions from './reactions/reactions';
import Tails from './tails/tails';

const Bubble = () => {
  const { tariff, widget } = useWidgetContext();
  const { accessToken } = useChatBodyContext();
  const { msg } = useMsgContext();

  const { t } = useTranslation();
  const isMutedDark = useIsMutedDark();

  const isOutgoing = getIsMsgOutgoing(accessToken, msg);
  const color = isMutedDark ? 'white' : 'dark';

  return (
    <div
      className="whatcrm-widget-message__bubble"
      style={
        isOutgoing
          ? { background: isMutedDark ? '#7f7f7f' : '#dfdfdf' }
          : undefined
      }
    >
      <div className="whatcrm-widget-message__content">
        {msg.quotedMsgId && <QuotedMsg />}

        {!isOutgoing && (
          <Text
            color={color}
            fontSize={12}
            fontWeight={600}
            style={msg.type == 'file' ? { marginBottom: 4 } : undefined}
          >
            {msg.sender_name || t`Manager`}
          </Text>
        )}

        {msg.type == 'file' ? (
          <File />
        ) : msg.type == 'message' || msg.type == 'reaction' ? (
          <MsgText>{msg.content}</MsgText>
        ) : (
          <Plug />
        )}

        {tariff != null && tariff != 'Start' && <Reactions />}
      </div>

      {isOutgoing && <Ack />}

      {widget.chat_message_type == 'classic' ? (
        <Tails.Classic />
      ) : (
        widget.chat_message_type == 'retro' && <Tails.Retro />
      )}
    </div>
  );
};

export default Bubble;
